import { Navigate } from "react-router-dom";
import axios from "axios";

const Auth = ({ children }) => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    const userRole = localStorage.getItem('userRole');

    if (!token) {
        return <Navigate to="/" />;
    }
    else {
        axios.defaults.headers.common['ImzaKey'] = token;
        axios.defaults.headers.common['Id'] = userId;
        axios.defaults.headers.common['Role'] = userRole;
        // axios.interceptors.request.use(function (config) {
        //     config.headers.Authorization = token;

        //     return config;
        // }, function (error) {
        //     return Promise.reject(error);
        // });
    }
    return children;
};



export default Auth;
